import React from 'react';
import ShimmerComponent from '../../common/shimmerComponent/shimmerComponent';
import SoundWaveIcon from '../../../assets/svgComponents/SoundWaveIcon';

import './voiceMsgUploadingLoader.css';

const VoiceMsgUploadingLoader = (largeUI = false) => {
  return (
    <div className="et-voice-msg-loader-container">
      {/* Left: Circular shimmer with spinner */}
      <div className="et-voice-msg-loader-left">
        <div className="et-voice-msg-loader-left-shimmer">
          <ShimmerComponent />
        </div>
      </div>

      {/* Right: Shimmer with soundwave */}
      <div className="et-voice-msg-loader-right">
        <div className="et-voice-msg-loader-right-shimmer">
          <ShimmerComponent />
        </div>
        <div className="et-voice-msg-loader-soundwave">
          <SoundWaveIcon
            width={largeUI === true ? 999 : 188}
            fillColor={'#A8C0FA6F'}
          />
        </div>
      </div>
    </div>
  );
};

export default VoiceMsgUploadingLoader;
